import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import ScrollToTopOnMount from 'components/UI/ScrollToTopOnMount';
import clsx from 'clsx';
import Header from 'components/Header/Header';
// import ContactForm from './ContactForm';
import BlockRatio from 'components/BlockRatio';
import Banner from 'components/Banner/Banner';
import Template from 'components/Template/Template';
import i18n from 'helpers/i18n';
//import { getCurrentUserRole } from 'components/UI/Account/ducks/authentication';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Fade from '@material-ui/core/Fade';
import Footer from '../Footer';
import Immutable from 'immutable';
import queryString from 'query-string';

const styles = (theme) => {
  return {
    root: {
      // minHeight: '1024px',
      // height: '100%',
      width: '100%',
      '& .MuiTypography-h3': {
        color: '#fff',
      },
      // display: "flex",
      // flexDirection: "column",
      // "& > *": {
      //   flex: 1,
      // },
    },
    pageTitle: {
      paddingTop: 16,
      paddingBottom: 16,
      color: theme.palette.primary.main,
      textAlign: 'center',
      fontSize: '2.2rem',
      backgroundColor: '#fff',
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      boxShadow: theme.shadows[3],
      [theme.breakpoints.down('md')]: {
        fontSize: '1.8rem',
      },
      [theme.breakpoints.down('sm')]: {
        fontSize: '1.5rem',
      },
      [theme.breakpoints.down('xs')]: {
        fontSize: '1.3rem',
      },
    },

    whiteBg: {
      position: 'relative',
      marginBottom: theme.spacing(4),
      '&:before': {
        position: 'absolute',
        left: 0,
        top: 0,
        content: "' '",
        width: '100%',
        height: '100%',
        backgroundColor: theme.palette.background.paper,
        opacity: 0.9,
      },
    },

    paperWrapper: {
      display: 'block',
      width: '100%',
    },
    paper: {
      padding: theme.spacing(4),
      position: 'relative',
      backgroundColor: 'transparent',
    },
    header: {
      height: 150,
      [theme.breakpoints.down('sm')]: {
        height: 150,
      },
    },
    content: {
      // height: 'calc(100% - 150px - 120px)',
      minHeight: '620px',
      [theme.breakpoints.down('sm')]: {
        height: 'auto',
      },
    },
    footer: {
      height: 120,
      [theme.breakpoints.down('sm')]: {
        height: 'auto',
      },
    },
  };
};

class Medias extends Component {
  render() {
    const { classes } = this.props;
    const uri = queryString.parse(window.location.search);
    const $$initValues = uri.s && uri.s === '3' ? Immutable.fromJS({ subject: 'rpps' }) : undefined;
    return (
      <Template current={'medias'} headerImage="background" fixedSizeThreshold={712} >
        <Fade in timeout={1000} style={{ width: '100%' }}>
          <div className={classes.root}>
            <Typography variant="h2" className={classes.pageTitle}>
              {i18n.get('mediasTitle')}
            </Typography>{' '}
            <Box className={clsx(classes.paperWrapper, classes.whiteBg)}>
              <Paper square elevation={0} className={classes.paper}>
                <Typography variant='h4' gutterBottom>Le Syndrome de l’Intestin Irritable en 2020 : "leaky gut syndrom" - mythe ou réalité ?</Typography>
                <Typography variant='body1' gutterBottom>De la théorie à la pratique : discussion avec les experts<br />
                Dr Philippe GODEBERGE, Pr Jean-Marc SABATE, Pr Véronique VITTON
              </Typography>
                <Box width="100%" mt={2}>
                  <BlockRatio ratio="16_9">
                    <iframe src="https://player.vimeo.com/video/480019626" width="100%" height="100%" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
                  </BlockRatio>
                </Box>
              </Paper>
            </Box>
          </div>
        </Fade>
      </Template>
    );
  }
}

function mapStateToProps(state) {
  const props = {
    //userRole: getCurrentUserRole(state),
  };
  return props;
}

export default withStyles(styles)(connect(mapStateToProps)(Medias));



// WEBPACK FOOTER //
// ./src/components/Medias/Medias.jsx